<template>
  <div
    class="bg-gray-900 rounded-xl p-4 mt-4 text-sm text-white"
    :class="showDetail ? 'expand' : 'collapse'"
    @click="showDetail = !showDetail"
  >
    <div class="grid grid-cols-1">
      <span class="flex items-center">
        <DeviceMobileIcon class="h-5 w-5 text-yellow-300" />
        <span class="mr-1">موبایل : </span>
        <span class="mr-1">{{ suggest.mobile }}</span>
      </span>
      <span class="flex mt-2">
        <CalendarIcon class="h-5 w-5 text-yellow-300" />
        <span class="mr-1">تاریخ : </span>
        <span class="mr-1">{{ suggest.surveY_DATE }}</span>
      </span>
    </div>
    <div class="grid grid-cols-1 mt-2 mb-2">
      <span class="flex items-center">
        <ClockIcon class="h-5 w-5 text-yellow-300" />
        <span class="mr-1">ساعت : </span>
        <span class="mr-1">{{ suggest.surveY_TIME }}</span>
      </span>
    </div>
    <div
      class="grid grid-cols-2 gap-y-4 mt-4 border border-yellow-300 rounded-md p-2 text-white"
      v-show="showDetail"
      @click.stop
    >
      <p>{{ suggest.surveY_TEXT }}</p>
    </div>
  </div>
</template>
<script>
import {
  DeviceMobileIcon,
  CalendarIcon,
  ClockIcon,
} from "@heroicons/vue/outline";
export default {
  name: "ReportSuggest",
  props: ["suggest"],
  components: { DeviceMobileIcon, CalendarIcon, ClockIcon },
  data() {
    return {
      showDetail: false,
    };
  },
};
</script>
